import React, { useEffect, useState } from 'react';
import { Button, Col, Flex, Form, Select, Tooltip } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { LuArrowDownUp } from "react-icons/lu";
import StatusComponent from '../../../globalComponents/StatusComponent';
import EventEmitter from '../../../utils/eventEmitter';
import SmartButton from '../../../globalComponents/SmartButton';
import useStockCountAPI from '../../apis/stockCountAPI';
import { FloatingLabel } from 'flowbite-react';
import stockSheet from '../../utils/stockSheet';
import { jsPDF } from "jspdf";




const StockCountChanges = () => {
  const [form] = Form.useForm();
  const { stockCount, locations } = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();
  const {create, update, startCount, submitStockCount, validateStockCount, generateStockSheets, cancelCount} = useStockCountAPI();
  const [name, setName] = useState(stockCount.reference ? stockCount.reference : '');

  const onChangeName = e => setName(e.target.value);

  const handleSubmit = () => { 
    let data = form.getFieldsValue();
    data['reference'] = name;
    data['seo'] = name.toLowerCase().replaceAll(' ', '-');
    create(data);
  };

  const handleStartCount = () => {
    let data = form.getFieldsValue();
    data['reference'] = name;
    data['seo'] = name.toLowerCase().replaceAll(' ', '-');
    const location_id = data.location_id;
    startCount(stockCount.id, data);
    setTimeout(() => {
      navigate('/inventory/stock-counts/'+params.action+'/inventory-lines/'+location_id);
    }, 5000);
  };
  // console.log(locations);
  const handleContinueCount = () => { 
    const location_id = stockCount.location_id;
    navigate('/inventory/stock-counts/'+params.action+'/inventory-lines/'+location_id);
  };

  const handleSubmitStockCount = () => { 
    submitStockCount(stockCount.id);
  };

  const handleValidateCount = () => { 
    validateStockCount(stockCount.id);
  };

  const handlePrintSheet = async () => { 
    try {
      const sheets = await generateStockSheets(stockCount.id);
      // Generate the dynamic HTML content
      const dynamicHTML = stockSheet(sheets.lines, sheets);
  
      // Create a jsPDF instance
      const doc = new jsPDF('p', 'mm', 'a4');
  
      // Use html method of jsPDF to convert HTML to PDF
      doc.html(dynamicHTML, {
        callback: function (doc) {
          // Automatically download the PDF file after rendering
          doc.save('Stock Sheet.pdf');
        },
        x: 10,
        y: 10,
        width: 190, // match the width of the receipt (80mm)
        windowWidth: 800, // Adjust the window width if needed
      });
    }catch (err) {
      console.log(err);
    }
  };

  const handleCancel = () => { };

  useEffect(() => {
    EventEmitter.subscribe('stockcount_response', data => {
      navigate('/inventory/stock-counts/'+data);
    });

    return () => EventEmitter.unsubscribe('stockcount_response');
  },[])

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/stock-counts/'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Stock Counts</Link> / {stockCount.reference}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ stockCount.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {stockCount.seo && 
        <div className='flex justify-between bg-white'>
          <Flex wrap='wrap' align='center' gap={'small'} style={{maxWidth: '70%'}}>
          {stockCount.status === 'draft' && <Button size='small' type='primary' onClick={handleStartCount} className='font-semibold bg-[#189aa0] hover-btn'>START COUNT</Button>}
            {stockCount.status === 'in_progress' &&
              <>
                {stockCount.count_state === 'waiting' && 
                  <>
                    <Button size='small' type='primary' onClick={handleContinueCount} className='font-semibold bg-[#189aa0] hover-btn'>CONTINUE COUNT</Button>
                    <Button size='small' type='primary' onClick={handleSubmitStockCount} className='font-semibold bg-[#189aa0] hover-btn'>SUBMIT STOCK COUNT</Button>
                  </>
                }
                {stockCount.count_state === 'submitted' && 
                <>
                  <Button size='small' type='primary' onClick={handleContinueCount} className='font-semibold bg-[#189aa0] hover-btn'>VIEW COUNT</Button>
                  <Button size='small' type='primary' onClick={handleValidateCount} className='font-semibold bg-[#189aa0] hover-btn'>VALIDATE STOCK COUNT</Button>
                </>}
                <Button size='small' type='text' onClick={handlePrintSheet} className='font-semibold text-[#189aa0]'>PRINT COUNT SHEET</Button>
                <Button size='small' type='text' onClick={handleCancel} className='font-semibold text-[#189aa0]'>CANCEL</Button>
              </>
            }
            {stockCount.status ==='validated' && <Button size='small' type='text' onClick={handlePrintSheet} className='font-semibold text-[#189aa0]'>PRINT COUNT SHEET</Button>}
          </Flex>
          <StatusComponent formValue={stockCount} name={'STOCK_COUNT'}/>
        </div>
        }
        
      </div>
      <div className='mt-5 bg-white shadow relative' style={{ minHeight: '200px'}}>
        {(stockCount.status === 'validated' || stockCount.status === 'done') && 
          <Flex className='border-b m-0' justify='flex-end'>
            <SmartButton icon={<LuArrowDownUp size={'1.4rem'} />} number={'Product'} text={'Moves'} to={`/inventory/stock-counts/${stockCount.id}/product-moves`} className='border-s-2'/>
          </Flex>
        }
        <div className="ribbon ribbon-top-right o_widget">
            {stockCount.count_state === 'waiting' && 
              <span className="text-blue-600 bg-blue-500">
                Waiting
              </span>
            }
            {stockCount.count_state === 'submitted' && <span style={{backgroundColor: '#24ad32'}}>Submitted</span>}
        </div>
        
        <Form 
          form={form}
          labelAlign='left'
          className='p-3'
          labelCol={{span: 9}}
          initialValues={stockCount.seo ? stockCount :
            {}
          }
          variant='borderless'
          disabled = {(stockCount.status !== 'draft' && stockCount.status !== undefined) ? true : false}
        >
          <Col md={{span: 12}}>
            <FloatingLabel
              className='text-2xl'
              variant="standard"
              readOnly={stockCount.status !== 'draft' ? true : false}
              // disabled={formValue.status!== 'discard' ? true : false}
              label="Reference"
              value={name} 
              onChange={onChangeName}
            />
            {/* <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Simulatneous Conditions To Met</Badge> */}
            <Form.Item labelCol={{md: {span: 5}}} label={'Location'} name={'location_id'} className='font-semibold '>
              <Select options={locations.map(location => ({value: location.id, label: location.name }))}/>
            </Form.Item>
          </Col>
        </Form>
      </div>
    </div>
  )
}
export default StockCountChanges;